import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    '&:hover': {
      backgroundColor: theme.tokens.colors.bg.greyscale.secondary,
    },
  },
}));
